import Config from '~/config/config';
import { ConfigType } from '~/config/config';

import { BaseService } from './BaseService';
import axios, { AxiosResponse } from 'axios';

import i18n from '~/i18n';

import { SchoolDataResponse } from './types/school';

export * from './types/school';

// The default domain is efmdglobal. The only usecase of this variable is on localhost :P
export const DEFAULT_DOMAIN = 'efmdglobal';

export default class SchoolService extends BaseService {
    constructor() {
        super('identity/university', true);
    }

    static initialize() {
        document.title = ''.concat((Config.rawConfig.school.domain + '').toUpperCase(), ' ', i18n.t(
            'general.documentTitle'
        ) as string);
    }

    // Static methods that just use the config file
    static getCurrentSchoolId(): number {
        return Config.rawConfig.school.schoolId;
    }

    static getCurrentSchoolDomain(): string {
        return Config.rawConfig.school.domain;
    }

    static getCurrentSchoolName(): string {
        return Config.rawConfig.school.name;
    }

    static getCurrentSchoolConfig(): ConfigType['school'] {
        return Config.rawConfig['school'];
    }

    // Methods that require API calls
    async getAllSchools(): Promise<SchoolDataResponse[]> {
        return axios({
            url: this.getUrl(''),
            method: 'GET',
        }).then((data: AxiosResponse<SchoolDataResponse[]>) => {
            return data.data;
        });
    }

    async getSchoolDataById(id: number): Promise<SchoolDataResponse> {
        return axios({
            url: this.getUrl(`${id}`),
            method: 'GET',
        }).then((data: AxiosResponse<SchoolDataResponse>) => {
            return data.data;
        });
    }
}
